<script setup>
import { computed } from 'vue'
import { formatPhone, normalizePhone } from '@/lib/whatsapp'
import WhatsappButton from '@/components/WhatsappButton.vue'
import QuoteButton from '@/components/QuoteButton.vue'

const props = defineProps({
  phone: { type: String, required: true }
})

const readablePhone = computed(() => formatPhone(props.phone))
// "Guarda el número" is an instruction, so the number has to be actionable:
// tapping it opens the dialer, where a contact can be saved.
const telHref = computed(() => `tel:+${normalizePhone(props.phone)}`)
</script>

<template>
  <section id="contacto" class="bg-linen text-ink scroll-mt-16">
    <!-- The rule spans the page grid; only the copy is centred and narrow. -->
    <div class="mx-auto max-w-7xl px-6 lg:px-10">
      <div class="mx-auto max-w-3xl border-t border-ink/12 py-16 text-center lg:py-24">
        <!-- Acá el logo va solo: no lleva al lado el nombre escrito, como sí
             pasa en la barra y en el pie, así que es él quien tiene que decir
             de quién es la marca. Por eso es el único de los tres con alt. -->
        <img
          src="/lumina-isologo.png"
          alt="Casa Lumina"
          class="mx-auto mb-6 h-12 w-auto"
          width="182"
          height="160"
        >
        <p class="eyebrow text-glow-ink">Cotización sin costo</p>

        <h2 class="display mx-auto mt-5 max-w-2xl text-balance text-[clamp(2.1rem,5vw,3.75rem)]">
          Mándanos las medidas de tu ventana.
        </h2>

        <div class="mt-8 flex flex-col items-center gap-4">
          <!-- Los dos canales lado a lado: el formulario relleno y WhatsApp en
               contorno, mismo tamaño. El cierre invitaba solo a WhatsApp. -->
          <div class="flex flex-wrap items-center justify-center gap-4">
            <QuoteButton size="large" label="Pedir cotización" source="closing" variant="ink" />

            <WhatsappButton
              :phone="phone"
              variant="outline"
              size="large"
              label="WhatsApp"
              subject="cotizar cortinas a medida"
              source="closing"
            />
          </div>

          <p class="text-sm text-ink-soft">
            o guarda el número:
            <a
              :href="telHref"
              class="inline-block px-1 py-3 font-semibold text-ink underline decoration-ink/25 underline-offset-4 transition-colors hover:decoration-ink"
            >
              {{ readablePhone }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
